import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'welcome-space',
  children: {
    guideIdentifier: {
      path: ':guideIdentifier',
    },
  },
} as const satisfies Location
